import * as React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import * as _ from 'lodash';
import {Omit} from '@material-ui/core';
import {StandardTextFieldProps} from "@material-ui/core/TextField/TextField";

export interface SearchFieldProps extends Omit<StandardTextFieldProps, 'onChange'> {
  onChange(value: string);
}

const SearchField: React.SFC<SearchFieldProps> = ({onChange, value, ...props}) => <TextField
  onChange={({target: {value}}) => onChange(value)}
  InputProps={{
    startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>,
    endAdornment: _.isEmpty(value) ? undefined : <InputAdornment position="end"><IconButton onClick={() => onChange('')}><ClearIcon/></IconButton></InputAdornment>
  }} value={value} {...props}/>;

export default SearchField;
